import { configureStore } from '@reduxjs/toolkit';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { rootReducer } from './reducer';
import purgeMiddleware from './middleware/purgeMiddleware';

const persistConfig = {
    key: 'root',
    storage,
    whitelist: ['auth'], // persist only auth slice
}

const persistedReducer = persistReducer(persistConfig, rootReducer)

export const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }).concat(purgeMiddleware),

})

export const persistor = persistStore(store)